import { observable, action } from "mobx";

class StandardStore {
    @observable _forceRender: boolean = false;
    @action setForceRender = (value: boolean) => {
        this._forceRender = value;
    }
}

export default StandardStore;